import { getAuth } from "../../contexts/authStore";
import { getAppsyncUrl } from "../authenticate";


export async function putShift(scheduleId: string, shiftId: string, shiftName: string, daysOfWeek: string[], startTime: string, endTime: string, position: string, staffNeeded: string, assignedStaff: string[], isRecurring: boolean, shiftDate: string, notes: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putShift(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(shiftId)}, shiftName: ${JSON.stringify(shiftName)}, daysOfWeek: ${JSON.stringify(daysOfWeek)}
                , startTime: ${JSON.stringify(startTime)}, endTime: ${JSON.stringify(endTime)}, position: ${JSON.stringify(position)}
                , staffNeeded: ${JSON.stringify(staffNeeded)}, assignedStaff: ${JSON.stringify(assignedStaff)}, isRecurring: ${JSON.stringify(isRecurring)}
                ${!isRecurring ? ", shiftDate:" + JSON.stringify(shiftDate) : ""}, notes: ${JSON.stringify(notes)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putShift)
            })
        })
    }
}

export async function putShiftCancel(scheduleId: string, shiftId: string, shiftName: string, daysOfWeek: string[], startTime: string, endTime: string, position: string, staffNeeded: string, 
    assignedStaff: string[], isRecurring: boolean, shiftDate: string, notes: string, cancelShiftId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putShiftCancel(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(cancelShiftId)}, shiftName: ${JSON.stringify(shiftName)}, daysOfWeek: ${JSON.stringify(daysOfWeek)}
                , startTime: ${JSON.stringify(startTime)}, endTime: ${JSON.stringify(endTime)}, position: ${JSON.stringify(position)}
                , staffNeeded: ${JSON.stringify(staffNeeded)}, assignedStaff: ${JSON.stringify(assignedStaff)}, isRecurring: ${JSON.stringify(isRecurring)}
                , shiftDate: ${JSON.stringify(shiftDate)}, notes: ${JSON.stringify(notes)}, cancelShiftId: ${JSON.stringify(cancelShiftId)}
                , shiftReferenceId: ${JSON.stringify(shiftId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putShiftCancel)
            })
        })
    }
}

export async function getShifts(scheduleId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getShifts(scheduleId: ${JSON.stringify(scheduleId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getShifts)
            })
        })
    }
}

export async function getShift(scheduleId: string, shiftId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getShift(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(shiftId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getShift)
            })
        })
    }
}

export async function deleteShift(scheduleId: string, shiftId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                deleteShift(scheduleId: ${JSON.stringify(scheduleId)}, shiftId: ${JSON.stringify(shiftId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deleteShift)
            })
        })
    }
}